/**
 * Copyright Mántum All Rights Reserved.
 */
import Button from '..';
import type { PropTypes } from '..';

export default function Contained(props: PropTypes) {
    return (
        <Button
            className='inline-flex h-10 w-full items-center justify-center rounded-md border border-transparent bg-error px-4 py-2 text-base font-medium text-white outline-offset-2 outline-error-dark hover:bg-error-dark'
            loading={props.loading}
            onClick={props.onClick}
            testid={props.testid}
            title={props.title}
            truncate={props.truncate}
            disabled={props.disabled}
            type={props.type}
        >
            {props.children}
        </Button>
    );
}
